// Implementation referenced from: https://hmh.engineering/using-react-contextapi-usereducer-as-a-replacement-of-redux-as-a-state-management-architecture-336452b2930e
import React, { createContext, useContext, useReducer } from 'react';
import initialState from "./initialState";
import { fasterSchedulingReducer } from "./reducer";
/**
 * @type {import('react').Context<Partial<import('./store').IFasterSchedulingProps>>}
 */

const FasterSchedulingContext = /*#__PURE__*/createContext({
  state: initialState
});
export const useStore = () => useContext(FasterSchedulingContext);
export const FasterSchedulingContextProvider = ({
  children
}) => {
  const [state, dispatch] = useReducer(fasterSchedulingReducer, initialState);
  return (
    /*#__PURE__*/
    // @ts-ignore
    React.createElement(FasterSchedulingContext.Provider, {
      value: {
        state,
        dispatch
      }
    }, children)
  );
};